const navigationSubNav = function () {
    const setupNav = () => {
        if (window.innerWidth < 1280) {
            // Verhindern, dass mehrfach Eventlistener hinzugefügt werden
            if (!$('header .navbar-toggler').hasClass('resize-initialized')) {
                $('header .navbar-toggler')
                    .addClass('resize-initialized')
                    .on('click', function (event) {
                        event.preventDefault();
                        $('html, body, main').toggleClass('open-nav');
                        $(this).toggleClass('open');
                        $('nav, header, #header-main-nav-container').toggleClass('open');
                    });
            }

            const subNavTogglers = document.querySelectorAll('#header-main-nav-container #header-main-nav ul.menu li.children');

            subNavTogglers.forEach(subNavToggler => {
                if (!subNavToggler.classList.contains('resize-initialized')) {
                    subNavToggler.classList.add('resize-initialized');

                    subNavToggler.addEventListener('click', function () {
                        this.parentElement.classList.toggle('open');
                        this.classList.toggle('open');
                    });
                }
            });
        }
    };

    setupNav(); // Initial bei Page-Load

    window.addEventListener('resize', () => {
        setupNav(); // Bei Resize erneut prüfen und ggf. setzen
    });
};

export { navigationSubNav };
